import type { TOC } from '@ember/component/template-only';
import { and } from 'ember-truth-helpers';

export interface WarningBannerSignature {
  Args: {
    ctaHref?: string;
    ctaText?: string;
    secondaryCtaHref?: string;
    secondaryCtaText?: string;
    subtitle: string;
    title: string;
  };
  Element: HTMLDivElement;
}

export default <template>
  <div class="mx-auto bg-papaya-5 p-8 -ml-8 -mr-8 -mt-8" ...attributes>
    <div class="flex flex-auto flex-row items-center">
      <div class="flex flex-auto flex-col pr-6 text-papaya-60">
        <h3>{{@title}}</h3>
        <p class="m-0 text-base">{{@subtitle}}</p>
      </div>
      <div class="flex items-center">
        {{#if (and @secondaryCtaText @secondaryCtaHref)}}
          <a
            href={{@secondaryCtaHref}}
            class="btn btn--small btn--link !text-papaya-50 mr-8"
            data-test-wb-secondary-cta
          >
            {{@secondaryCtaText}}
          </a>
        {{/if}}
        {{#if (and @ctaText @ctaHref)}}
          <a href={{@ctaHref}} class="btn btn--orange btn--small" data-test-wb-primary-cta>
            {{@ctaText}}
          </a>
        {{/if}}
      </div>
    </div>
  </div>
</template> satisfies TOC<WarningBannerSignature>;
